import { REVIEWS_ORDER } from "~/util/providers/review";

export const REVIEWS_PER_PAGE = 20;
export const REVIEWS_PER_PAGE_FIRST_LOAD = 100;
export const SCROLL_TRESHOLD = 150;
export const SORT_OPTIONS: Array<{
	title: string;
	value: REVIEWS_ORDER,
}> = [{
	title: "mymap.reviews.sortDateDesc",
	value: "latest",
}, {
	title: "mymap.reviews.sortDateAsc",
	value: "oldest",
}, {
	title: "mymap.reviews.sortRatingDesc",
	value: "best",
}, {
	title: "mymap.reviews.sortRatingAsc",
	value: "worst",
}];

export const PAGE_MY = "my";
export const PAGE_SUGGEST = "suggest";
export const LOG_SOURCE = "recenze-my_maps";
export const SUGGESTRED_REVIEWS_PER_PAGE = 15;
